import React, {useEffect} from 'react';
import {withStyles} from '@mui/styles';
import {Button, Grid} from '@mui/material';
import {actions as opportunityActions, selectors as opportunitySelectors} from '../../../../Ducks/opportunity';
import {selectors as accountSelectors} from '../../../../Ducks/account';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import LostModalV2 from '../Modals/LostModalV2';
import {useParams} from 'react-router-dom';
import moment from 'moment';
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import List from '@ckeditor/ckeditor5-list/src/list';
import Link from '@ckeditor/ckeditor5-link/src/link';
import AutoLink from '@ckeditor/ckeditor5-link/src/autolink';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';
import Font from '@ckeditor/ckeditor5-font/src/font';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import CompletedCallNoteModal from './CompletedCallNoteModal';
import {NEW_SALE, PLANNED_ACTION, RESALE, WIN_BACK_TYPE} from "../../../Utils/constants";
import NewSaleLostModal from "../Modals/NewSaleLostModal";

const editorConfiguration = {
    plugins: [List, Essentials, Bold, Italic, Paragraph, Heading, Link, AutoLink, Indent, IndentBlock, Font, Alignment, Underline, Strikethrough, Table, TableToolbar, HorizontalLine, BlockQuote],
    toolbar: ['heading', '|', 'fontColor', 'fontBackgroundColor', '|', 'outdent', 'indent', '|', 'bold', 'italic', 'underline', 'strikethrough', '|', 'link', 'horizontalLine', 'blockQuote', '|', 'bulletedList', 'numberedList', '|', 'alignment:left', 'alignment:right', '|', 'insertTable', '|', 'undo', 'redo'],
    alignment: {
        options: ['left', 'right']
    },
    table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
    },
    placeholder: "Insert text here ..."
};

const useStyles = _theme => ({
    actionContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '24px !important'
    },
    missedCallBtn: {
        marginRight: '12px !important'
    },
    modal: {
        marginTop: '12px !important'
    },
    nextPhoneCallBtn: {
        marginTop: '4px !important',
        marginRight: '12px !important'
    }
});

let ckeditor5;

function ActiveCall(props) {
    const {
        classes,
        opportunity,
        user,
        postOpportunityAction,
        handleTabChange,
        opportunitySelectedTab,
        opportunitySelectedTab2,
        dateRange
    } = props;
    const [content, setContent] = React.useState('');
    const [modal, setModal] = React.useState(false);
    const [openLost, setOpenLost] = React.useState(false);
    const [_selectedTab, setSelectedTab] = React.useState(null);
    const [logCode, setLogCode] = React.useState(null);
    const [showCompletedCallNoteModal, setShowCompletedCallNoteModal] = React.useState(false);
    const [error, setError] = React.useState(null);
    const capability = user && user.user_details.capabilities.filter((item) => item.capability_title === "can_close_lost_with_unsuccessful_campaign");

    useEffect(() => {
        if (opportunity && ckeditor5) {
            let logContent = localStorage.getItem('active_call_information');
            if (logContent !== null) {
                const log_content = JSON.parse(logContent);
                if (log_content && log_content.opportunity_id !== props.params.id) {
                    localStorage.removeItem('active_call_information');
                    ckeditor5.setData("");
                }
            }
        }
    }, [opportunity, dateRange]);

    if (!opportunity) {
        return <div></div>
    }

    const handleModal = (modal) => {
        callOpportunityActionV2();

        if (modal === "openLost") {
            setOpenLost(true);
        }
    };

    const handleClick = (log_code) => {
        setLogCode(log_code);
        setModal(true);
    }

    const handleClose = () => {
        setOpenLost(false);
    };

    const switchTabs = (tab) => {
        let queryparams = `?action=${tab}`;
        if (logCode === 'missed_call')
            queryparams += `&type=add_update_event&opportunity_id=${opportunity.main.opportunity_id}`;

        window.history.replaceState(null, null, queryparams);
        setSelectedTab(tab);
        callOpportunityAction();
    }

    const storeValue = (content) => {
        const data = {
            opportunity_id: props.params.id,
            log_content: content
        }

        localStorage.setItem('active_call_information', JSON.stringify(data));
        setContent(content);

        if (content?.length) {
            let _error = {...error};
            delete _error.content;

            setError(_error);
        }
    }

    const clearActiveCallContent = () => {
        localStorage.removeItem('active_call_information');
        ckeditor5 && ckeditor5.setData("");
        setContent('');
    }

    const callOpportunityAction = (values = {}) => {
        let date = new Date();
        const obj = {
            action_type: PLANNED_ACTION,
            due_time: moment(date).format('YYYY-MM-DDTHH:mm:ssZ'),
            due_time_precise: 1
        };
        const postData = {
            opportunityId: props.params.id,
            obj: {
                "log_content": content,
                "log_title": logCode === "completed_call" ? "Completed Call" : "Missed Call",
                "log_code": logCode,
                ...values
            }
        }

        //postOpportunityAction sends an update call to existing opportunity action and marks existing action 'completed'
        //If a pending opportunity action/planned action does not exist then it creates a new one and marks it 'completed'
        postOpportunityAction({
            id: opportunity.main.opportunity_id,
            obj: obj,
            postData: postData,
            handleTabChange,
            selectedTab: opportunitySelectedTab,
            selectedTab2: opportunitySelectedTab2,
            dateRange: dateRange
        });
        clearActiveCallContent();
    }

    const callOpportunityActionV2 = (values = {}) => {
        let date = new Date();
        const obj = {
            action_type: PLANNED_ACTION,
            due_time: moment(date).format('YYYY-MM-DDTHH:mm:ssZ'),
            due_time_precise: 1
        };
        const postData = {
            opportunityId: props.params.id,
            obj: {
                "log_content": content,
                "log_title": logCode === "completed_call" ? "Completed Call" : "Missed Call",
                "log_code": logCode,
                ...values
            }
        }

        //postOpportunityAction sends an update call to existing opportunity action and marks existing action 'completed'
        //If a pending opportunity action/planned action does not exist then it creates a new one and marksR it completed
        postOpportunityAction({
            id: opportunity.main.opportunity_id,
            obj: obj,
            postData: postData,
            dateRange: dateRange
        });
        clearActiveCallContent();
    }

    const handleCompletedCallNoteSubmit = (values) => {
        callOpportunityAction(values);
        props.handleTabChange('deal')
        setShowCompletedCallNoteModal(false);
    };

    const handleCallNoteClick = () => {
        if (!content?.length) {
            setError({...error, "content": "Please add a note"});
            return;
        }

        let date = new Date();
        const obj = {
            action_type: PLANNED_ACTION,
            due_time: moment(date).format('YYYY-MM-DDTHH:mm:ssZ'),
            due_time_precise: 1,
        };
        const postData = {
            opportunityId: props.params.id,
            obj: {
                "log_content": content,
                "log_title": logCode === "completed_call" ? "Completed Call" : "Missed Call",
                "log_code": logCode,
            }
        }

        //postOpportunityAction sends an update call to existing opportunity action and marks existing action 'completed'
        //If an pending opportunity action/planned action does not exist then it creates a new one and mark it completed
        postOpportunityAction({
            id: opportunity.main.opportunity_id,
            obj: obj,
            postData: postData,
            dateRange: dateRange
        });
        clearActiveCallContent();
    };

    return (
        <div className="active-call-tab">
            <CompletedCallNoteModal open={showCompletedCallNoteModal} onSubmit={handleCompletedCallNoteSubmit}
                                    onClose={() => setShowCompletedCallNoteModal(false)}/>
            <CKEditor
                editor={ClassicEditor}
                config={editorConfiguration}
                data={content}
                onReady={(editor) => {
                    ckeditor5 = editor;
                    let logContent = localStorage.getItem('active_call_information');
                    if (logContent !== null) {
                        const log_content = JSON.parse(logContent);
                        if (log_content && log_content.opportunity_id === props.params.id) {
                            setContent(log_content.log_content);
                        }
                    }
                }}
                onChange={(_, editor) => {
                    storeValue(editor.getData())
                }}
                onBlur={(_event, editor) => {
                    storeValue(editor.getData());

                }}
            />
            {error?.content && (
                <p style={{color: 'red', marginTop: '4px'}}>
                    {error.content}
                </p>
            )}
            {
                opportunity && opportunity.main.self_opportunity && opportunity.main.opportunity_status === "open" && (
                    <div className={classes.actionContainer}>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => handleClick('missed_call')}
                            className={classes.missedCallBtn}
                        >
                            Missed Call
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => handleClick('completed_call')}
                        >
                            Completed Call
                        </Button>
                    </div>
                )
            }
            {
                modal &&
                <Grid className={classes.modal} container spacing={4}>
                    <Grid item xs={4}>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => handleModal('openLost')}
                            className={classes.missedCallBtn}
                            size="large"
                            fullWidth
                        >
                            Closed:lost
                        </Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => handleCallNoteClick()}
                            fullWidth
                            className={classes.missedCallBtn}
                            size="small"
                        >
                            {logCode === 'missed_call' ? 'Missed call' : 'Completed Call'} - Note
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => switchTabs('planned_action')}
                            fullWidth
                            size="small"
                            className={classes.nextPhoneCallBtn}
                        >
                            plan next action
                        </Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => {
                                if (opportunity.main.opportunity_type == 'resale') {
                                    callOpportunityActionV2();
                                    props.handleTabChange('deal')
                                } else {
                                    setShowCompletedCallNoteModal(true);
                                }
                            }}
                            size={opportunity && capability.length > 0 ? "large" : "medium"}
                        >
                            Ready for closed:won
                        </Button>
                    </Grid>
                </Grid>
            }

            <LostModalV2
                open={openLost && opportunity?.main.opportunity_type === RESALE}
                onClose={handleClose}
                opportunity={opportunity}
            />

            <NewSaleLostModal
                open={openLost && (opportunity?.main.opportunity_type === NEW_SALE || opportunity?.main.opportunity_type === WIN_BACK_TYPE)}
                onClose={handleClose}
                opportunity={opportunity}
            />
        </div>
    );
}

const mapStateToProps = (state) => ({
    errorMessage: opportunitySelectors.errorMessage(state),
    opportunityActiveCallActionResponse: opportunitySelectors.opportunityActiveCallActionResponse(state),
    user: accountSelectors.user(state),
});
const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        opportunityActiveCallAction: opportunityActions.opportunityActiveCallAction,
        postOpportunityAction: opportunityActions.postOpportunityAction,
    },
    dispatch);

function WithNavigate(props) {
    let params = useParams();
    return <ActiveCall {...props} params={params}/>
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(WithNavigate));